/* @flow */
import * as React from 'react';

import {colors} from 'shells/colors';
import {AutoDistributionBoltIcon} from 'shells/icon';

export const AUTO_RESOLVE_ID = 'auto-resolve';
export const SAME_ASSIGNEE_ID = 'same-assignee';

export const AUTO_ASSIGN_OPTION = {
    id: AUTO_RESOLVE_ID, // need a unique id which we set to null before sending it to the backend
    name: 'Follow pipeline assignment rules',
    type: 'users',
    avatarUrl: '/include/images/icon-auto-assign_2x.png',
    isEnabled: true,
};

export const AUTO_DISTRIBUTE_OPTION = {
    value: AUTO_RESOLVE_ID, // need a unique id which we set to undefined/null before sending it to the backend
    label: (
        <div className='flex gap-4'>
            <AutoDistributionBoltIcon size={12} color={colors.grey} /> Auto distribute
        </div>
    ),
};

export const SAME_ASSIGNEE_OPTION = {
    id: SAME_ASSIGNEE_ID,
    name: 'Same assignee',
    type: 'users',
    avatarUrl: '/include/images/icon-auto-assign_2x.png',
    isEnabled: true,
};
